module.exports = __webpack_public_path__ + "img/camera-netatmo.b78f2df6.png";